/**
 * API envelope contract (spec section 36).
 *
 * Success: { success: true, data, meta? }
 * Failure: { success: false, error: { code, message, details? } }
 *
 * Both the Fastify error handler and the web API client depend on this shape,
 * so it lives in shared rather than being duplicated.
 */
/**
 * Stable, client-consumable error codes. The web app branches on these, so
 * they are part of the public contract — add, don't rename.
 */
export const API_ERROR_CODES = [
    // 400 / 422
    'VALIDATION_ERROR',
    'BAD_REQUEST',
    'INVALID_STATE_TRANSITION',
    'INSUFFICIENT_STOCK',
    'COUPON_INVALID',
    'CART_EMPTY',
    'TOTAL_MISMATCH',
    // 401 / 403
    'UNAUTHENTICATED',
    'INVALID_CREDENTIALS',
    'ACCOUNT_LOCKED',
    'ACCOUNT_INACTIVE',
    'EMAIL_NOT_VERIFIED',
    'TOKEN_EXPIRED',
    'TOKEN_INVALID',
    'FORBIDDEN',
    'INSUFFICIENT_PERMISSIONS',
    'CSRF_TOKEN_INVALID',
    'SUPPORT_ACCESS_EXPIRED',
    'SUPPORT_ACCESS_READ_ONLY',
    'STORE_SUSPENDED',
    'PLAN_LIMIT_REACHED',
    'PLAN_EXPIRED',
    'PLAN_FEATURE_UNAVAILABLE',
    // 404 / 409
    'NOT_FOUND',
    'MERCHANT_NOT_FOUND',
    'CONFLICT',
    'DUPLICATE_RESOURCE',
    'SLUG_TAKEN',
    'EMAIL_TAKEN',
    // 429
    'RATE_LIMIT_EXCEEDED',
    // 5xx
    'INTERNAL_ERROR',
    'SERVICE_UNAVAILABLE',
    'PAYMENT_PROVIDER_ERROR',
];
export function isApiErrorResponse(value) {
    return (typeof value === 'object' &&
        value !== null &&
        'success' in value &&
        value.success === false &&
        'error' in value);
}
export function buildPaginationMeta(page, pageSize, total) {
    const totalPages = pageSize > 0 ? Math.ceil(total / pageSize) : 0;
    return {
        page,
        pageSize,
        total,
        totalPages,
        hasNextPage: page < totalPages,
        hasPreviousPage: page > 1,
    };
}
//# sourceMappingURL=api.js.map